import { render } from "./MissingDev.vue?vue&type=template&id=533632c4"
import script from "./MissingDev.vue?vue&type=script&lang=ts"
export * from "./MissingDev.vue?vue&type=script&lang=ts"
script.render = render

export default script